import React from "react";
import UploadEmailCSV from "../../components/UploadEmailCSV";
import { canUseEmailValidator, hasFullAccess } from "../../utils/userAccess";

export default function ValidateEmails() {
    if (!hasFullAccess() && !canUseEmailValidator()) {
        return (
            <div className="container p-4">
                <h3>Access Denied</h3>
                <p className="text-muted">Email Validator access is not enabled for your account.</p>
            </div>
        );
    }

    return (
        <div className="container">
            <div className="crm-page-header">
                <div>
                    <h1 className="crm-page-title">Email Validator</h1>
                    <p className="crm-page-subtitle">Deep validation before bulk campaigns</p>
                </div>
            </div>
            <UploadEmailCSV />
        </div>
    );
}
